/**
 * Escapes text for a Quasar Dialog/Notify created with `html: true`.
 *
 * Those dialogs render `title`/`message` as HTML, so a record's name, a description, an
 * e-mail or a reason the user typed must go through here before being concatenated into
 * the markup; otherwise `<img src=x onerror=...>` saved in a record runs in the browser
 * of whoever opens the dialog (and can read the token in localStorage). The surrounding
 * markup (`<b>`, `<br>`) stays as HTML; only the data is escaped.
 */
const ENTIDADES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function escaparHtml(texto) {
  if (texto === null || texto === undefined) return '';
  return String(texto).replace(/[&<>"']/g, c => ENTIDADES[c]);
}

export default escaparHtml;

/**
 * Copy of a value with every string inside it escaped (objects and arrays included).
 *
 * For formatters that build markup around record fields and feed v-html, like the
 * `formatDisplay` every autocomplete parent passes in: giving them this copy keeps their
 * own <strong>/<br> and neutralises the data. Only for display; never send the copy back.
 */
export function escaparCampos(valor, vistos = new WeakMap()) {
  if (typeof valor === 'string') return escaparHtml(valor);
  if (!valor || typeof valor !== 'object') return valor;
  if (vistos.has(valor)) return vistos.get(valor);
  const copia = Array.isArray(valor) ? [] : {};
  vistos.set(valor, copia);
  for (const [chave, v] of Object.entries(valor)) copia[chave] = escaparCampos(v, vistos);
  return copia;
}
